<template>
  <div class="account-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>账户中心</h2>
    </div>

    <!-- 余额卡片 -->
    <el-card class="balance-card">
      <div class="balance-header">
        <div class="balance-info">
          <div class="balance-label">账户积分</div>
          <div class="balance-amount">{{ balance.toFixed(0) }}</div>
        </div>
        <el-button type="primary" size="large" @click="handleRecharge">
          <i class="el-icon-plus"></i> 立即充值
        </el-button>
      </div>
      <div class="balance-stats">
        <div class="stat-item">
          <div class="stat-value">{{orgPriceDetail.score_unit_count}}积分</div>
          <div class="stat-label">¥1</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{orgPriceDetail.lead_price}}积分/条</div>
          <div class="stat-label">线索</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{orgPriceDetail.msg_price}}积分/条</div>
          <div class="stat-label">发送私信</div>
        </div>
      </div>
    </el-card>

    <!-- 标签页：充值记录 & 消费明细 -->
    <el-card class="records-card">
      <el-tabs v-model="activeTab">
        <!-- 充值记录 -->
        <el-tab-pane label="充值记录" name="recharge">
          <el-table :data="rechargeRecords" v-loading="loading.recharge" stripe>
            <el-table-column prop="order_no" label="订单号" min-width="180" />
            <el-table-column prop="amount" label="充值金额" width="120">
              <template slot-scope="scope">
                <span class="amount-positive">+¥{{ scope.row.amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="积分数" min-width="180" />
            <el-table-column prop="payment_method" label="支付方式" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.payment_method === 'wxpay' ? 'success' : 'primary'" size="small">
                  {{ scope.row.payment_method === 'wxpay' ? '微信支付' : '支付宝' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)" size="small">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="充值时间" width="180">
              <template slot-scope="scope">
                {{ formatTime(scope.row.created_at) }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination @current-change="handleRechargePageChange" :current-page="rechargePagination.page"
              :page-size="rechargePagination.pageSize" layout="total, prev, pager, next"
              :total="rechargePagination.total" />
          </div>
        </el-tab-pane>

        <!-- 消费明细 -->
        <el-tab-pane label="消费明细" name="cost">
          <el-table :data="costRecords" v-loading="loading.cost" stripe>
            <el-table-column prop="type" label="消费类型" width="120">
              <template slot-scope="scope">
                <el-tag :type="getCostTypeType(scope.row.type)" size="small">
                  {{ getCostTypeText(scope.row.type) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="消费金额" width="120">
              <template slot-scope="scope">
                <span class="amount-negative">-¥{{ scope.row.amount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="description" label="消费说明" min-width="200" show-overflow-tooltip />
            <el-table-column prop="balance_after" label="余额" width="120">
              <template slot-scope="scope">
                ¥{{ scope.row.balance_after.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="消费时间" width="180">
              <template slot-scope="scope">
                {{ formatTime(scope.row.created_at) }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination @current-change="handleCostPageChange" :current-page="costPagination.page"
              :page-size="costPagination.pageSize" layout="total, prev, pager, next" :total="costPagination.total" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 充值弹窗 -->
    <recharge-modal ref="rechargeModal" @recharged="handleRecharged" />
  </div>
</template>

<script>
import RechargeModal from './RechargeModal'

export default {
  name: 'AccountPage',
  components: { RechargeModal },

  data() {
    return {
      //定价策略
      orgPriceDetail: {},
      // 余额信息
      balance: 0,
      totalRecharge: 0,
      totalCost: 0,

      // 当前标签页
      activeTab: 'recharge',

      // 加载状态
      loading: {
        recharge: false,
        cost: false
      },

      // 充值记录
      rechargeRecords: [],
      rechargePagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },

      // 消费明细
      costRecords: [],
      costPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },

  mounted() {
    this.fetchBalance()
    this.fetchRechargeRecords()
    this.fetchCostRecords()
    this.fetchOrgDetail()


  },

  computed: {
    // 获取用户ID
    userId() {
      return this.$store.getters.getUserId
    }
  },

  methods: {
    // 获取余额信息
    async fetchBalance() {
      if (!this.userId) return
      try {
        const { data } = await this.$http.get(`/RechargeTransaction/balance/${this.userId}`)
        if (data.meta?.status === 200) {
          this.balance = data.data.balance || 0
          this.totalRecharge = data.data.total_recharge || 0
          this.totalCost = data.data.total_consume || 0
        }
      } catch (error) {
        console.error('获取余额失败:', error)
      }
    },

    // 获取余额信息
    async fetchOrgDetail() {
      try {
        const { data } = await this.$http.get(`/users/getorg/${this.$store.state.user_login_info.organize_id}`)
        if (data.meta?.status === 200) {
          if (data.data.length > 0) {
            this.orgPriceDetail = data.data[0]
          }

          console.log("this.orgPriceDetail....", this.orgPriceDetail)
        }
      } catch (error) {
        console.error('获取余额失败:', error)
      }
    },

    // 获取充值记录
    async fetchRechargeRecords() {
      if (!this.userId) return
      this.loading.recharge = true
      try {
        const params = {
          user_id: this.userId,
          pagenum: this.rechargePagination.page,
          pagesize: this.rechargePagination.pageSize
        }
        const { data } = await this.$http.get('/RechargeTransaction/recharge-records', { params })
        if (data.meta?.status === 200) {
          // 映射 API 返回字段到表格字段
          this.rechargeRecords = (data.data.records || []).map(record => ({
            order_no: record.order_no,
            amount: record.amount,
            payment_method: 'alipay', // 目前只支持支付宝
            status: 'success', // 充值记录都是成功的
            created_at: record.create_time * 1000 // 时间戳转换为毫秒
          }))
          this.rechargePagination.total = data.data.total || 0
        }
      } catch (error) {
        console.error('获取充值记录失败:', error)
      } finally {
        this.loading.recharge = false
      }
    },

    // 获取消费明细
    async fetchCostRecords() {
      if (!this.userId) return
      this.loading.cost = true
      try {
        const params = {
          user_id: this.userId,
          pagenum: this.costPagination.page,
          pagesize: this.costPagination.pageSize
        }
        const { data } = await this.$http.get('/RechargeTransaction/consume-records', { params })
        if (data.meta?.status === 200) {
          // 映射 API 返回字段到表格字段
          this.costRecords = (data.data.records || []).map(record => ({
            type: 'sms', // 默认类型
            amount: record.amount,
            description: record.remark || '消费',
            balance_after: record.balance_after,
            created_at: record.create_time * 1000 // 时间戳转换为毫秒
          }))
          this.costPagination.total = data.data.total || 0
        }
      } catch (error) {
        console.error('获取消费记录失败:', error)
      } finally {
        this.loading.cost = false
      }
    },

    // 打开充值弹窗
    handleRecharge() {
      this.$refs.rechargeModal.show()
    },

    // 充值成功回调
    handleRecharged() {
      this.fetchBalance()
      this.fetchRechargeRecords()
    },

    // 充值记录分页
    handleRechargePageChange(page) {
      this.rechargePagination.page = page
      this.fetchRechargeRecords()
    },

    // 消费明细分页
    handleCostPageChange(page) {
      this.costPagination.page = page
      this.fetchCostRecords()
    },

    // 状态样式
    getStatusType(status) {
      const types = {
        pending: 'warning',
        success: 'success',
        failed: 'danger'
      }
      return types[status] || 'info'
    },

    // 状态文字
    getStatusText(status) {
      const texts = {
        pending: '处理中',
        success: '成功',
        failed: '失败'
      }
      return texts[status] || status
    },

    // 消费类型样式
    getCostTypeType(type) {
      const types = {
        sms: 'primary',
        ai: 'warning',
        other: 'info'
      }
      return types[type] || 'info'
    },

    // 消费类型文字
    getCostTypeText(type) {
      const texts = {
        sms: '私信发送',
        ai: 'AI服务',
        other: '其他'
      }
      return texts[type] || type
    },

    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.account-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

/* 余额卡片 */
.balance-card {
  margin-bottom: 20px;
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #ebeef5;
}

.balance-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.balance-amount {
  font-size: 36px;
  font-weight: bold;
  color: #f56c6c;
}

.balance-stats {
  display: flex;
  padding-top: 20px;
}

.stat-item {
  flex: 1;
  text-align: center;
  border-right: 1px solid #ebeef5;
}

.stat-item:last-child {
  border-right: none;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

/* 记录卡片 */
.records-card {
  min-height: 500px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

/* 金额样式 */
.amount-positive {
  color: #67c23a;
  font-weight: bold;
}

.amount-negative {
  color: #f56c6c;
  font-weight: bold;
}
</style>
